<template>
  <div :class="{'is-invalid': hasError()}">
    <slot />
    <div class="form-invalid-feedback" v-if="hasError()">
      {{getError()}}
    </div>
  </div>
</template>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormOptionGroup",
  mixins: [formField],
  props: {
    field: String
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
  }
};
</script>